import React from 'react';
import { FeltFormatert } from 'src/api/v2';
import { Checkbox, Fieldset, Radio, Table } from '@innovationnorway/cl-react';

const OwiFormField = ({ field }: { field: FeltFormatert }) => {
  switch (field.type) {
    case 'heading':
      return null;

    case 'attachments':
      return (
        <div>
          <div className="display--flex flex-direction--column gap--2">
            {field.felter?.map((attachment) => (
              <a key={attachment.verdi} href={attachment.verdi ?? ''} download={attachment.navn}>
                {attachment.navn}
              </a>
            ))}
          </div>
        </div>
      );

    case 'checkbox': {
      const selectedValues = field.verdi?.split(',') ?? [];
      return (
        <Fieldset>
          <Fieldset.Legend>{field.navn}</Fieldset.Legend>
          {field.valg?.map((valg) => {
            const fieldValue = valg.verdi ?? valg.navn ?? '';
            return (
              <Checkbox
                key={fieldValue}
                label={valg.navn || ''}
                value={fieldValue}
                checked={selectedValues.includes(fieldValue)}
                readOnly
              />
            );
          })}
        </Fieldset>
      );
    }

    case 'slider':
    case 'radioButton':
      return (
        <Fieldset>
          <Fieldset.Legend>{field.navn}</Fieldset.Legend>
          {field.valg?.map((valg) => {
            const fieldValue = valg.verdi ?? valg.navn ?? '';
            return (
              <Radio
                key={fieldValue}
                label={valg.navn || ''}
                name={field.navn || ''}
                value={fieldValue}
                checked={fieldValue === field.verdi}
                readOnly
              />
            );
          })}
        </Fieldset>
      );

    case 'table': {
      if (!field.verdi) return null;
      const decimalNumberRegex = /^(\D*\d+)\.(\d\D*)$/;
      const [headerRow, ...dataRows] = field.verdi.split('\n');
      const headers = headerRow.split(',').map((c) => c.trim());
      const rows = dataRows.map((row) =>
        row
          .split(',')
          .map((c) => c.trim().replace(decimalNumberRegex, '$1,$2'))
          .slice(0, headers.length),
      );

      return (
        <div>
          <strong>{field.navn}</strong>
          <Table>
            <Table.Head>
              <Table.Row>
                {headers.map((header, i) => (
                  <Table.HeaderCell key={i}>{header}</Table.HeaderCell>
                ))}
              </Table.Row>
            </Table.Head>
            <Table.Body>
              {rows.map((row, rowIndex) => (
                <Table.Row key={rowIndex}>
                  {row.map((cell, cellIndex) => (
                    <Table.Cell key={cellIndex}>{cell}</Table.Cell>
                  ))}
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
      );
    }

    default:
      return (
        <div>
          <strong>{field.navn}</strong>
          <span className="display--block margin-top--2 max-inline-size--75">{field.verdi}</span>
        </div>
      );
  }
};

export default OwiFormField;
